import { Pagination } from '@material-ui/lab'

import { TenantListProps } from './TenantListDesktop'
import TenantTable from './TenantTable'
import useStyles from './styles/TenantListDesktop.styles'

const TenantListMobile: React.FC<TenantListProps> = ({
  refetch,
  filteredTenants,
  page,
  perPage,
  loading,
  numberOfPages,
  setPage
}) => {
  const classes = useStyles()
  return (
    <div>
      <TenantTable
        refetch={refetch}
        tenants={filteredTenants.slice((page - 1) * perPage, page * perPage)}
        loading={loading}
      />
      <div className={classes.paginationContainer}>
        <Pagination
          count={numberOfPages}
          color="primary"
          size="small"
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}
export default TenantListMobile
